import { Link } from 'react-router-dom';
import { footerColumns } from '@/mocks/footerColumns';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-football-line text-xl text-background-50"></i>
              </div>
              <span className="font-heading text-lg font-bold tracking-wide text-background-50">
                开云足球
              </span>
            </Link>
            <p className="text-foreground-400 text-sm leading-relaxed mb-4">
              开云足球 —— 专注足球赛事、数据分析与互动体验的综合平台。为您提供实时赛事资讯、精准数据支持与沉浸式足球互动服务。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-foreground-800 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-all duration-200" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-foreground-800 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-all duration-200" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-foreground-800 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-all duration-200" aria-label="抖音">
                <i className="ri-tiktok-line text-sm"></i>
              </a>
            </div>
          </div>

          {footerColumns.map((column) => (
            <div key={column.title}>
              <h3 className="font-heading text-sm font-semibold text-background-50 mb-4 tracking-wider uppercase">
                {column.title}
              </h3>
              <ul className="flex flex-col gap-3">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-foreground-400 hover:text-background-200 text-sm transition-colors duration-200"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 md:mt-14 pt-6 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs">
            &copy; {new Date().getFullYear()} 开云足球 版权所有 | 保留一切权利
          </p>
          <div className="flex items-center gap-4">
            <Link to="/about" className="text-foreground-500 hover:text-background-300 text-xs transition-colors">
              隐私政策
            </Link>
            <Link to="/about" className="text-foreground-500 hover:text-background-300 text-xs transition-colors">
              服务条款
            </Link>
            <Link to="/about#contact" className="text-foreground-500 hover:text-background-300 text-xs transition-colors">
              联系我们
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}